/**
 * @generated SignedSource<<cc19219ffac04d84358b88d84dd7a912>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteMultipleTimeRegsInput = {
  ids?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteMultipleTimeRegsMutation$variables = {
  input: DeleteMultipleTimeRegsInput;
};
export type deleteMultipleTimeRegsMutation$data = {
  readonly deleteMultipleTimeRegs: {
    readonly deletedTimeRegIds: ReadonlyArray<string | null> | null;
    readonly viewer: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type deleteMultipleTimeRegsMutation = {
  variables: deleteMultipleTimeRegsMutation$variables;
  response: deleteMultipleTimeRegsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMultipleTimeRegsPayload",
    "kind": "LinkedField",
    "name": "deleteMultipleTimeRegs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTimeRegIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteMultipleTimeRegsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteMultipleTimeRegsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "78b443968d86c73fb0e4ecbb7e122a14",
    "id": null,
    "metadata": {},
    "name": "deleteMultipleTimeRegsMutation",
    "operationKind": "mutation",
    "text": "mutation deleteMultipleTimeRegsMutation(\n  $input: DeleteMultipleTimeRegsInput!\n) {\n  deleteMultipleTimeRegs(input: $input) {\n    deletedTimeRegIds\n    viewer {\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9d4cc0420d989b702a25847057d4a4f";

export default node;
